export default __webpack_public_path__ + "static/media/volcano_mint.088ec3de.png";